import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';

import {
  FormModeEnum,
  ToolbarItem,
  NotificationService,
  ModalService,
  BackendService,
  FieldStructure,
  TableSettings,
  TableActionEnum,
  UtilService,
  FieldTypeEnum,
  TableComponent,
  ListService,
} from 'beyond-util';
import { SifarnikBase } from '../sifarnik-base/sifarnik-base';
import { BackendService as RtsBackendService } from '../../../services/backend.service';
import { EndpointTypes } from '../../../enums/enpoint-types.enum';
import { FormCode } from '../../../enums/form-code.enum';
import { FormName } from '../../../enums/form-name.enum';
import { ValidationService } from '../../../services/validation.service';
import { ActionType } from '../../../enums/action-type.enum';
import { RasporedService } from '../../../services/raspored.service';
import * as moment from 'moment';
import { EnumService } from '../../../services/enum.service';
import {
  EMISIJA_GENERISI_RASPOREDE,
  EMISIJA_AZURIRAJ_RASPOREDE_CENAMA,
} from '../../../constants/tooltip-messages';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-emisije',
  templateUrl: './emisije.component.html',
})
export class EmisijeComponent extends SifarnikBase
  implements OnInit, OnDestroy {
  private rasporediPlaceholder: TableComponent;
  @ViewChild('rasporediPlaceholder') set rasporedi(content: TableComponent) {
    if (content) {
      this.rasporediPlaceholder = content;
    }
  }

  private _subscriptions: Array<Subscription> = [];
  private _data: any[];
  public showDetails = false;
  public rasporediRange: any = {};

  public rasporediSettingsTable: TableSettings;
  public rasporediList: any[] = [];
  public skipRasporedUpdateWithTrajanje = false;

  public validateSubject: Subject<any> = new Subject<any>();
  public validateSubject$ = this.validateSubject.asObservable();
  public rasporediListBeforeEditing: any;
  public rasporediListCount: any;
  private Privilegije: Array<string> = [];
  private rasporediIzmenjenaCena: any[] = [];
  private rasporedOsnovnaCenaSek: any;

  get isEditOrAddMode(): boolean {
    return this.mode === FormModeEnum.Edit || this.mode === FormModeEnum.Add;
  }


  public tooltipOptions = {
    placement: 'top',
    'show-delay': '500',
    theme: 'light',
  };

  constructor(
    protected _backendService: BackendService,
    protected _modalService: ModalService,
    protected _notificationService: NotificationService,
    private _rtsBackendService: RtsBackendService,
    private _validationService: ValidationService,
    private _enumService: EnumService,
    private _rasporedService: RasporedService,
    private _spinner: NgxSpinnerService,
    private _listService: ListService
  ) {
    super(_backendService, _modalService, _notificationService);
  }

  public tooltips = { EMISIJA_GENERISI_RASPOREDE };

  ngOnInit() {
    setTimeout(() => {
      this._spinner.show();
      this._enumService.fetchProgrami();
      this._enumService.fetchNacinEmitovanja();
      this._enumService.fetchUcestalostEmitovanja();
      super.ngOnInit();
    });
  }

  ngOnDestroy() {
    this._subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }

  changeName() {
    if (typeof this.order === 'undefined') {
      return;
    }

    if (this.order.hasOwnProperty('naziv')) {
      this.name = this.order.naziv;
    } else if (this.mode === FormModeEnum.Add) {
      this.name = 'Nova emisija';
    } else if (this.order.hasOwnProperty('id')) {
      this.name = 'Emisija';
    }
  }

  loadSettings() {
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSEMI_EMI,
          FormName.PregledEmisija,
          EndpointTypes.AllEntities,
          this.filterQuery
        )
        .subscribe(data => {
          this._spinner.hide();

          if (!this.settingsTable) {
            this.disableInlineActions(data.Settings);
            this.setSettings(data.Settings);
          }
          this._data = data.ServiceData.Data;
          this._dataCount = data.ServiceData.DataSumCount;
          this.setAllFields();
          this.refreshTable();
          this.rasporediIzmenjenaCena = [];
        })
    );
  }

  refreshTable() {
    this.setId(this._data);

    this.orderListCount = this._dataCount;
    this.orderList = this._data;
  }

  create() {
    this.saveData();
  }

  onEmisijaChange(event: any) {
    let message = '';

    switch (event.fieldMap.fieldKey) {
      case 'Trajanje':
        if (!this.shouldUpdate(event)) {
          return;
        }
        message = `Trajanje emisije je promenjeno sa ${event.oldValue} na ${event.newValue} sekundi. Da li želite da ažurirate i vreme trajanja svih rasporeda za ovu emisiju?`;
        this.showMessageAndUpdate(message, 'Trajanje');
        break;

      case 'OsnovnaCenaCPP':
        if (!this.shouldUpdate(event)) {
          return;
        }
        message = `Osnovna Cena po CPP emisije je promenjena sa ${
          event.oldValue
        } na ${UtilService.formatDecimal(
          event.newValue
        )}. Da li želite da ažurirate i sve rasporede za ovu emisiju?`;
        this.showMessageAndUpdate(message, 'OsnovnaCenaCPP');
        break;

      case 'OsnovnaCenaSek':
        if (!this.shouldUpdate(event)) {
          return;
        }
        message = `Osnovna Cena po sekundi emisije je promenjena sa ${
          event.oldValue
        } na ${UtilService.formatDecimal(
          event.newValue
        )}. Da li želite da ažurirate i sve rasporede za ovu emisiju?`;
        this.showMessageAndUpdate(message, 'OsnovnaCenaSek');
        break;
      case 'VremeEmitovanja':
        if (event.newValue) {
          if (!this._validationService.validateHHmm(event.newValue)) {
            this._notificationService.notyError(
              'Vreme emitovanja nije validnog formata.'
            );

            return;
          }
          if (!this.shouldUpdate(event)) {
            return;
          }
          message = `Vreme emitovanja emisije je promenjeno sa ${event.oldValue} na ${event.newValue}. Da li želite da ažurirate i sve rasporede za ovu emisiju?`;
          this.showMessageAndUpdate(message, 'VremeEmitovanja');
        }
        break;

      case 'ProgramId':
        this.order.ProgramNaziv = this._enumService.programi.find(
          p => p.Id === event.newValue
        ).Naziv;

        if (!this.shouldUpdate(event)) {
          return;
        }

        const stariNaziv = this._enumService.programi.find(
          p => p.Id === event.oldValue
        ).Naziv;

        message = `Program emisije je promenjen sa ${stariNaziv} na ${this.order.ProgramNaziv}. Da li želite da ažurirate i sve rasporede za ovu emisiju?`;
        this.showMessageAndUpdate(message, 'ProgramId');
        break;
    }
  }

  showMessageAndUpdate(message: string, field: string) {
    this._modalService.openModal(message, (response: any) => {
      if (response) {
        this.updateRasporedi(field);
      }
    });
  }

  shouldUpdate(event: any): boolean {
    return (
      this.rasporediList &&
      this.rasporediList.length &&
      event.oldValue !== null &&
      event.oldValue !== event.newValue
    );
  }

  getPayload() {
    const payload = { ...this.order };
    payload.Rasporedi = [...this.rasporediList];

    payload.VremeEmitovanja = payload.VremeEmitovanja;
    payload.Rasporedi.forEach(r => {
      r.EmisijaSifra = this.order.Sifra;
      r.EmisijaNaziv = this.order.Naziv;
      r.VremeEmitovanja = r.VremeEmitovanja;
    });
    payload.RasporediIzmenjenaCena = this.rasporediIzmenjenaCena;

    return payload;
  }

  updateRasporedi(field: string) {
    this.order.Rasporedi = this.rasporediList.map(r => {
      if (field === 'OsnovnaCenaSek' && r[field] !== this.order[field]) {
        this.dodajNovuCenuZaRaspored(r.Id, this.order.OsnovnaCenaSek);
      }

      r[field] = this.order[field] ? this.order[field] : null;

      if (field === 'Trajanje') {
        r.Preostalo = this.order.Trajanje - r.Zauzeto;
      } else if (field === 'ProgramId') {
        r.ProgramNaziv = this.order.ProgramNaziv;
      }

      return r;
    });
  }

  // private checkSpecifikacijeZaEmisiju(): Observable<any> {
  //   const ids = this.rasporediIzmenjenaCena.map(function(v){
  //     return v.Id;
  //   });
  //   const payload = this._rtsBackendService.getRequestPayload(
  //     FormCode.MSSPEC_EMIEMI,
  //     FormName.PregledEmisija,
  //     EndpointTypes.PostEntity,
  //     ``,
  //     ids,
  //     null,
  //     true
  //   );

  //   return this._rtsBackendService.fetchMediaPlanSettings(payload);
  // }

  dodajRed() {
    if(this.mode === FormModeEnum.Edit || this.mode === FormModeEnum.Add) {
      return this.rasporediPlaceholder.onInlineAddOpenFromHeader();
    }
  }

  goToBottom() {
    window.scrollTo(0, document.body.scrollHeight);
  }

  goToTop(topButton: HTMLElement) {
    window.scrollTo(0, 0);
  }

  addOrder() {
    if (this.validateField('Sifra')) {
      this._notificationService.notyError(
        'Šifra ne sme da sadrži karaktere "\\" i "/". '
      );

      return;
    }

    if (this.validateField('Naziv')) {
      this._notificationService.notyError(
        'Naziv ne sme da sadrži karaktere "\\" i "/". '
      );

      return;
    }
    this.validateSifraProgram(ActionType.Create);
  }

  saveUpdate(actionType: ActionType) {
    this.setActionType(actionType);
    this.validateSubject.next();
  }

  validateSifraProgram(actionType: ActionType) {
    const sifra: string = this.order['Sifra'];
    const program: string = this.getProgramNaziv(this.order['ProgramId']);
    if ((program === 'RTS1 TV' && !sifra.startsWith('10-')) ||
        (program === 'RTS2 TV' && !sifra.startsWith('20-')) ||
        ((program === 'RTS SVET' || program === 'Svet') && !sifra.startsWith('40-'))) {
          const message = `Da li ste sigurni da je za kanal ${program} ovo dogovorena šifra?`;
          this._modalService.openModal(message, (response: any) => {
            if (response) {
              this.saveUpdate(actionType);
            }
          });
        } else {
          this.saveUpdate(actionType);
        }
  }

  saveData() {
    this._spinner.show();
    const payload = this.getPayload();

    this._subscriptions.push(
      this._rtsBackendService
        .save(FormCode.MSEMI_EMI, FormName.PregledEmisija, payload)
        .subscribe(response => {
          this.openServiceError(response);
          this.loadSettings();
        })
    );
  }

  updateData() {
    this._spinner.show();
    const payload = this.getPayload();

    this._subscriptions.push(
      this._rtsBackendService
        .update(FormCode.MSEMI_EMI, FormName.PregledEmisija, payload)
        .subscribe(response => {
          if (this.responseHasError(response)) {
            this.notifyErrorFromResponse(response);
            this._spinner.hide();

            return;
          } else {
            this.loadSettings();
            this.changeMode(FormModeEnum.Table);
            this._spinner.hide();
          }
        })
    );
  }

  update() {
    if (this.isValid()) {
      this.updateData();
    }
  }

  validateField(fieldName: string) {
    const field = this.order[fieldName];

    return field.includes('\\') || field.includes('/');
  }

  onEditMode() {
    this._orderBeforeEditing = { ...this.order };
    this.rasporediListBeforeEditing = this.deepCopyFunction(this.rasporediList);

    this.setToolbarOptions({
      items: [ToolbarItem.ItemSave(), ToolbarItem.ItemCancel()],
    });
  }

  onCancel() {
    this.order = { ...this._orderBeforeEditing };
    this.rasporediList = this.deepCopyFunction(this.rasporediListBeforeEditing);

    this.changeMode(FormModeEnum.View);
  }

  isValid(): boolean {
    let valid = true;
    if (!this._validationService.validateNumber(this.order.Trajanje)) {
      this._notificationService.notyError(
        'Niste uneli dobar format za trajanje.'
      );

      valid = false;
    }

    return valid;
  }

  updateOrder() {
    if (this.validateField('Sifra')) {
      this._notificationService.notyError(
        'Šifra ne sme da sadrži karaktere "\\" i "/". '
      );

      return;
    }

    if (this.validateField('Naziv')) {
      this._notificationService.notyError(
        'Naziv ne sme da sadrži karaktere "\\" i "/". '
      );

      return;
    }
    this.validateSifraProgram(ActionType.Update);
  }

  onDeleteConfirm() {
    this._spinner.show();
    this._subscriptions.push(
      this._rtsBackendService
        .delete(FormCode.MSEMI_EMI, FormName.PregledEmisija, this.order.Id)
        .subscribe((response: any) => {
          if (response && response.Error) {
            this._notificationService.notyError(response.Error.ErrorMessage);
            this._spinner.hide();

            return;
          }

          this._notificationService.openNoty('Uspešno brisanje');
          this.changeMode(FormModeEnum.Table);
          this.loadSettings();
        })
    );
  }

  onAddMode() {
    this.setToolbarOptions({
      items: [ToolbarItem.ItemSave()],
    });
  }

  onTableActionView() {
    this.fetchSingleEntity(this.order.Id);
    this.changeMode(FormModeEnum.View);
    this.setToolbar();
  }

  onTableActionAdd() {
    this.fetchSingleEntity();
    this.changeMode(FormModeEnum.Add);
  }

  onTableActionFilter(event: any) {
    this._spinner.show();
    super.onTableActionFilter(event);
  }

  fetchSingleEntity(orderId = null) {
    this._spinner.show();
    this.showDetails = false;

    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSEMI_EMI,
          FormName.PregledEmisija,
          EndpointTypes.SingleEntity,
          '',
          orderId
        )
        .subscribe(data => {
          this._spinner.hide();
          this.order = orderId ? data.ServiceData[0] : {};
          this.order.DatumPocetkaEmitovanja = orderId
            ? this.order.DatumPocetkaEmitovanja
            : new Date();
          this.splitDetails(data.Settings, 7);
          this.fieldStructure = new FieldStructure(data.Settings, 'header');
          this.rasporediSettingsTable = new TableSettings(
            data.Settings.details[0],
            'table'
          );
          this.Privilegije = data.Privilegije;
          this.rasporediList = orderId ? data.ServiceData[0].Rasporedi : [];
          this.rasporediRange = this.setMinMaxRasporediRange();
          this.rasporediListCount = this.rasporediList.length;
          this.setRbr(this.rasporediList);
          this.showDetails = true;
          this.setInfobar(true, 'Marina Milenkovic', 1558801076316);

          if (this.order.Id) {
            this.setToolbar();
          }
        })
    );
  }

  onRasporedValueChanged(event) {}

  checkDatumiUcestalost(): boolean {
    return (
      this.order.DatumPocetkaEmitovanja &&
      this.order.DatumZavrsetkaEmitovanja &&
      this.order.UcestalostId
    );
  }

  onViewMode() {
    this.setToolbar();
  }

  setToolbar() {
    this.onViewModeWithParams(
      this.Privilegije.includes('MSEMI_EMI_CREATE'),
      this.Privilegije.includes('MSEMI_EMI_DELETE'),
      this.Privilegije.includes('MSEMI_EMI_UPDATE')
    );
  }

  tryToGenerateSchedule() {
    if (!this.checkDatumiUcestalost()) {
      this.notifyError(
        'Niste uneli sva potrebna polja za generisanje rasporeda.'
      );

      return;
    }
    this._modalService.openModal(
      `Ukoliko potvrdite kreiraćete novi raspored za period od ${moment(
        this.order.DatumPocetkaEmitovanja
      )
        .format('DD/MM/YYYY')
        .split('/')
        .join('.')} do ${moment(this.order.DatumZavrsetkaEmitovanja)
        .format('DD/MM/YYYY')
        .split('/')
        .join('.')}.`,
      (response: any) => {
        if (response) {
          this._rasporedService.createNewRaspored(this.order);
          this.rasporediList = [
            ...this.rasporediList,
            ...this._rasporedService.getRaspored(),
          ];
          this.setRbr(this.rasporediList);
          this.rasporediRange = this.setMinMaxRasporediRange();
        }
      }
    );
  }

  alterRasporedEditSettings() {
    this.rasporediSettingsTable.getFieldByName('Zauzeto').editable = false;
    this.rasporediSettingsTable.getFieldByName('Zauzeto').additable = false;
    this.rasporediSettingsTable.getFieldByName(
      'DatumEmitovanja'
    ).editable = false;
    this.rasporediSettingsTable.getFieldByName(
      'DatumEmitovanja'
    ).additable = false;
    this.rasporediSettingsTable.getFieldByName('Trajanje').additable = false;
    this.rasporediSettingsTable.getFieldByName('Trajanje').editable = false;
    this.rasporediSettingsTable.getFieldByName('Preostalo').editable = false;
    this.rasporediSettingsTable.getFieldByName('Preostalo').additable = false;
  }

  alterRasporedAddSettings() {
    this.rasporediSettingsTable.getFieldByName('Zauzeto').editable = false;
    this.rasporediSettingsTable.getFieldByName('Zauzeto').additable = false;
    this.rasporediSettingsTable.getFieldByName(
      'DatumEmitovanja'
    ).editable = true;
    this.rasporediSettingsTable.getFieldByName(
      'DatumEmitovanja'
    ).additable = true;
    this.rasporediSettingsTable.getFieldByName('Trajanje').additable = false;
    this.rasporediSettingsTable.getFieldByName('Trajanje').editable = false;
    this.rasporediSettingsTable.getFieldByName('Preostalo').editable = false;
    this.rasporediSettingsTable.getFieldByName('Preostalo').additable = false;
  }

  getProgramNaziv(programId) {
    return this._listService
      .getEnum('MSEMI_EMI_ProgramIdEnum')
      .find(p => p.value === programId).label;
  }

  rasporedTableAction(event: any) {
    switch (event.action) {
      case TableActionEnum.Update:
        event.document.ProgramNaziv = this.getProgramNaziv(
          event.document.ProgramId
        );
        if (this.rasporedOsnovnaCenaSek !== event.document.OsnovnaCenaSek) {
          this.dodajNovuCenuZaRaspored(
            event.document.Id,
            event.document.OsnovnaCenaSek
          );
        }
        break;
      case TableActionEnum.BeforeSave:
        if (
          !this._validationService.validateHHmm(
            this.rasporediList[event.index].VremeEmitovanja
          )
        ) {
          this.showRowError(
            event,
            'Vreme emitovanja na rasporedu nije validnog formata.',
            this.rasporediPlaceholder
          );
        }
        break;
      case TableActionEnum.Add:
        this.alterRasporedAddSettings();
        event.document.Zauzeto = 0;
        event.document.Trajanje = this.order.Trajanje;
        event.document.Preostalo = event.document.Trajanje;
        event.document.VremeEmitovanja = this.order.VremeEmitovanja;
        event.document.OsnovnaCenaCPP = this.order.OsnovnaCenaCPP;
        event.document.OsnovnaCenaSek = this.order.OsnovnaCenaSek;
        event.document.ProgramId = this.order.ProgramId;
        break;
      case TableActionEnum.Edit:
        this.alterRasporedEditSettings();
        this.rasporedOsnovnaCenaSek = event.document.OsnovnaCenaSek;
        break;
      case TableActionEnum.Save:
        event.document.OsnovnaCenaCPP = +event.document.OsnovnaCenaCPP;
        event.document.OsnovnaCenaSek = +event.document.OsnovnaCenaSek;
        this.rasporediRange = this.setMinMaxRasporediRange();
        event.document.ProgramNaziv = this.getProgramNaziv(
          event.document.ProgramId
        );
        break;
      case TableActionEnum.EditCancel:
        if (this.rasporediList.some(a => a['rbr'] === event.document['rbr'])) {
          this.copyProperties(
            event.document,
            this.rasporediList.filter(
              a => a['rbr'] === event.document['rbr']
            )[0]
          );
        }
        break;
    }
  }

  setMinMaxRasporediRange() {
    if (this.rasporediList && this.rasporediList.length > 0) {
      const momentDates = this.rasporediList.map(r =>
        moment(r.DatumEmitovanja)
      );
      const min = moment.min(momentDates);
      const max = moment.max(momentDates);

      return {
        datumOd: min,
        datumDo: max,
      };
    }
  }

  filtriraj(event) {
    if (moment(event.datumOd).isAfter(moment(event.datumDo))) {
      this.notifyError(
        'Zadati opseg datuma za ažuriranje cena na rasporedima nije validan.'
      );

      return;
    }

    const range = this._rasporedService.getRangeOfDates(
      moment(event.datumOd),
      moment(event.datumDo),
      'days'
    );

    range.forEach(d => {
      const rasp = this.rasporediList.find(r =>
        moment(r.DatumEmitovanja).isSame(moment(d))
      );

      if (rasp) {
        if (rasp.OsnovnaCenaSek !== this.order.OsnovnaCenaSek) {
          this.dodajNovuCenuZaRaspored(rasp.Id, this.order.OsnovnaCenaSek);
        }
        rasp.OsnovnaCenaCPP = this.order.OsnovnaCenaCPP;
        rasp.OsnovnaCenaSek = this.order.OsnovnaCenaSek;
      }
    });
  }

  dodajNovuCenuZaRaspored(rasporedId, osnovnaCenaSek) {
    const raspored = {
      Id: rasporedId,
      OsnovnaCenaSek: osnovnaCenaSek,
    };
    if (this.rasporediIzmenjenaCena.some(a => a.Id === rasporedId)) {
      this.rasporediIzmenjenaCena.find(
        a => a.Id === rasporedId
      ).OsnovnaCenaSek = osnovnaCenaSek;
    } else {
      this.rasporediIzmenjenaCena.push(raspored);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/emisije/emisije.component.ts